(function Tour() {

    /**
     * Create tour map
     * @param domObject
     * @constructor
     */
    function Map(domObject) {

        var startIcon = '/_Resources/Static/Packages/Bikealpin.Tour/Images/Map/pin-icon-start-variant.png';
        var endIcon = '/_Resources/Static/Packages/Bikealpin.Tour/Images/Map/pin-icon-end-variant.png';
        // initialize map
        var map = L.map(domObject,
            {
                maxZoom: 11,
                scrollWheelZoom: false
            });

        // add layers for visualization
        var OpenTopoMap = L.tileLayer('https://{s}.tile.opentopomap.org/{z}/{x}/{y}.png', {
            attribution: 'Map data: &copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors, <a href="http://viewfinderpanoramas.org">SRTM</a> | Map style: &copy; <a href="https://opentopomap.org">OpenTopoMap</a> (<a href="https://creativecommons.org/licenses/by-sa/3.0/">CC-BY-SA</a>)'
        });

        map.addLayer(OpenTopoMap);
        var control = L.control.layers(null, null).addTo(map);
        var bounds = null;


        this.addGpx = function(gpxFilePath) {
            new L.GPX(gpxFilePath, {
                async: true,
                marker_options: {
                    startIconUrl: '/_Resources/Static/Packages/Bikealpin.Tour/Images/Map/pin-icon-start-variant.png',
                    endIconUrl:   '/_Resources/Static/Packages/Bikealpin.Tour/Images/Map/pin-icon-start-variant.png',
                    shadowUrl:    '',
                    iconSize: [22, 30],
                    iconAnchor: [11, 30]

                },
                polyline_options: {
                    //color: '#95be33'
                    //color: '#ff9800'
                    color: '#FF1F00'
                }
            }).on('loaded', function(e) {
                var gpx = e.target;
                if(bounds === null) {
                    bounds = gpx.getBounds();
                } else {
                    bounds.extend(gpx.getBounds());
                }

                var zoom = $(domObject).data('zoom');
                if(zoom && !isNaN(zoom)) {
                    var center = bounds.getCenter();
                    map.setView(center, zoom);
                } else {
                    map.fitBounds(bounds);
                }

                control.addOverlay(gpx, gpx.get_name());
                var markers = $(domObject).find('.leaflet-marker-pane .leaflet-marker-icon:not(.processed)');
                // adjust markers
                for (var idx = 0, len = markers.length; idx < len; idx++) {
                    var ele = $(markers[idx]);
                    ele.addClass('processed');
                    // first marker
                    if(idx === 0) {
                        ele.attr('src', startIcon);
                        ele.addClass('tour-start');
                        continue;
                    }
                    // last marker
                    if(idx === markers.length - 1) {
                        ele.attr('src', endIcon);
                        ele.addClass('tour-end');
                        continue;
                    }
                    // remove all other markers
                    ele.remove();
                }
            }).addTo(map);
        };

        this.addGpx($(domObject).data('gpx-source'));

        if($(domObject).data('gpx2-source')) {
            this.addGpx($(domObject).data('gpx2-source'));
        }
    }

    $(document).ready(function () {
        $('.js-tour-map').each(function(idx, ele) {
            var map = new Map(ele);
        });
    });
})();

